import { queryClient } from 'AppProvider';
import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';
import { GET_TESTING_RESULT_BY_COURSE_ID } from './retrieveTestResult';

const UPLOAD_SESSION_VIDEO = (id: Number, courseId: number) =>
  `/v2/teacher/course/${courseId}/session/${id}/teacher-session-video`;

export type UploadSessionVideoBody = {
  id: number;
  formData: FormData;
  courseId: number;
};

export type UploadSessionVideoResponse = {
  sessionVideo?: string[];
  _data?: {
    homeWork: {
      // eslint-disable-next-line camelcase
      section_id: number;
    };
  };
};
export const uploadSessionVideo = ({
  id,
  courseId,
  formData,
}: UploadSessionVideoBody) => {
  return httpClient.post<UploadSessionVideoResponse>(
    UPLOAD_SESSION_VIDEO(id, courseId),
    formData,
    {
      headers: {
        ContentType:
          'multipart/form-data; boundary=----WebKitFormBoundaryRrouvXOkU01wCDJt',
      },
    },
  );
};

export const useUploadSessionVideo = (
  opts?: UseMutationOptions<
    AxiosResponse<UploadSessionVideoResponse>,
    AxiosError<any>,
    UploadSessionVideoBody
  >,
) => {
  return useMutation<
    AxiosResponse<UploadSessionVideoResponse>,
    AxiosError<any>,
    UploadSessionVideoBody
  >(uploadSessionVideo, {
    ...opts,
    onSuccess: (response, variables, context) => {
      const { courseId } = variables;
      // Update cache immediately with uploaded videos from response
      if (response.data.sessionVideo) {
        queryClient.setQueryData(
          GET_TESTING_RESULT_BY_COURSE_ID(courseId),
          (old: any) => ({
            ...old,
            data: {
              ...old?.data,
              data: {
                ...old?.data?.data,
                video_url: response.data.sessionVideo,
              },
            },
          }),
        );
      }
      // Also invalidate to ensure consistency on next refetch
      queryClient.invalidateQueries(GET_TESTING_RESULT_BY_COURSE_ID(courseId));
      opts?.onSuccess?.(response, variables, context);
    },
  });
};
